import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { logAuthUserActivity } from 'lib/logAuthUserActivity'
import { flowRight } from 'lodash'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'

const LogAuthUserActivity = () => {
    const { key } = useLocation()

    useEffect(() => {
        logAuthUserActivity()
    }, [key])

    return null
}

export default flowRight(
    withErrorBoundaryNoRender,
)(LogAuthUserActivity)
